/* eslint-disable jsx-a11y/label-has-for */
/**
 * Created by mh on 2018/5/27.
 */
import React from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import WaveSurfer from 'wavesurfer.js';
import TimelinePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.min.js';
import MinimapPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.minimap.min.js';
import RegionsPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.regions.min.js';
// import Cursor from 'wavesurfer.js/dist/plugin/wavesurfer.cursor.min.js';
import keydown, { keydownScoped, ALL_KEYS } from 'react-keydown';

import { MdPlayArrow, MdPause, MdFastForward, MdFastRewind, MdSkipNext, MdLoop } from 'react-icons/md';
import { FaSave } from 'react-icons/fa';

import config from '../config';
import { secondsToHHMMSSFFF, hHMMSSFFFToSeconds } from './TimingHelpers';

import './AudioPlayer.scss';


// TODO Make configurable
const markersDefinition = [
    {
        name: 'Mark In', key: 'MarkIn', alternativeKeys: ['Offset'], keyboardShortcut: 'i', color: '#ee4d00',
    },
    {
        name: 'Link In', key: 'LinkIn', keyboardShortcut: 'm', color: '#00FF00',
    },
    {
        name: 'Hook In', key: 'HookIn', keyboardShortcut: 'h', color: '#d231ff',
    },
    {
        name: 'Hook Out', key: 'HookOut', keyboardShortcut: 'j', color: '#d231ff',
    },
    {
        name: 'Link Out', key: 'LinkOut', keyboardShortcut: 'n', color: '#00FF00',
    },
    {
        name: 'Mark Out', key: 'MarkOut', keyboardShortcut: 'o', color: '#0095ff',
    },
];

const markerRow = (marker, value, set, reset, play, move) => (
    <tr key={marker.key}>
        <td>{marker.name}</td>
        <td><input type="text" className="form-control form-control-sm" value={value} readOnly placeholder="00:00:00:00" /></td>
        <td>
            <button className="btn btn-outline-primary btn-sm" onClick={(evnt) => { set(marker); evnt.currentTarget.blur(); }}>
                Set {marker.keyboardShortcut ? ` (${marker.keyboardShortcut})` : ''}
            </button>
        </td>
        <td><button className="btn btn-outline-primary btn-sm" onClick={(evnt) => { reset(marker); evnt.currentTarget.blur(); }}>Reset</button></td>
        <td><button className="btn btn-outline-primary btn-sm" onClick={(evnt) => { play(marker); evnt.currentTarget.blur(); }}><MdPlayArrow /></button></td>
        <td><button className="btn btn-outline-primary btn-sm" onClick={(evnt) => { move(marker, -0.1); evnt.currentTarget.blur(); }}><MdFastRewind /></button></td>
        <td><button className="btn btn-outline-primary btn-sm" onClick={(evnt) => { move(marker, 0.1); evnt.currentTarget.blur(); }}><MdFastForward /></button></td>
    </tr>);

@inject('auth') @observer @keydown
class AudioPlayer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isPlaying: false,
            loop: false,
            zoomLevel: 1,
        };

        const { metadata } = this.props;
        markersDefinition.map((m) => {
            this.state[m.key] = secondsToHHMMSSFFF(0); // Default
            if (metadata && metadata[m.key]) {
                this.state[m.key] = metadata[m.key];
            } else if (m.alternativeKeys) {
                m.alternativeKeys.map((a) => {
                    if (metadata && metadata[a]) {
                        this.state[m.key] = metadata[a];
                    }
                    return a;
                });
            }
            return m;
        });
        console.log('[AUDIOPLAYER] INITIAL State', this.state);
    }

    componentDidMount() {
        const options = {
            container: '#waveform',
            backend: 'MediaElement', // Force MediaElement backend
            height: 250,
            // barWidth: 1,
            responsive: true,
            waveColor: config.media.player.styling.colors.waveColor,
            progressColor: config.media.player.styling.colors.progressColor,
            loaderColor: config.media.player.styling.colors.loaderColor,
            cursorColor: config.media.player.styling.colors.cursorColor,
            plugins: [
                TimelinePlugin.create({
                    container: '#wave-timeline',
                }),
                MinimapPlugin.create({
                    // container: 'waveform-minimap',
                    height: 50,
                    showRegions: true,
                    showOverview: true,
                    overviewBorderColor: config.media.player.styling.colors.cursorColor,
                    overviewBorderSize: 2,
                }),
                // Cursor.create(), // Does not yet work properly
                RegionsPlugin.create({
                    dragSelection: {
                        slop: 5,
                    },
                }),
            ],
        };

        // TODO check this out
        // if (location.search.match('scroll')) {
        // options.minPxPerSec = 100;
        options.scrollParent = true;
        // }
        //
        // if (location.search.match('normalize')) {
        //     options.normalize = true;
        // }
        // ... initialising waveform with plugins
        this.wavesurfer = WaveSurfer.create(options);

        // Disable regions drag
        // TODO this does not work yet
        this.wavesurfer.regions.disableDragSelection();

        // Register events
        this.wavesurfer.on('play', () => {
            console.log('[AUDIOPLAYER] play');
            this.setState({
                isPlaying: true,
            });
        });
        this.wavesurfer.on('pause', () => {
            console.log('[AUDIOPLAYER] paused');
            this.setState({
                isPlaying: false,
            });
        });
        this.wavesurfer.on('error', () => {
            console.log('[AUDIOPLAYER] error');
        });
        this.wavesurfer.on('finish', () => {
            console.log('[AUDIOPLAYER] finish');
            if (this.state.loop) {
                this.wavesurfer.stop();
                this.wavesurfer.play(0);
            }
        });
        this.wavesurfer.on('ready', () => {
            console.log('[AUDIOPLAYER] ready');
            // Create regions
            this.wavesurfer.clearRegions();
            markersDefinition.map((m) => {
                const seconds = hHMMSSFFFToSeconds(this.state[m.key]);
                console.log('[AUDIOPLAYER] Setting marker', m, seconds);
                if (seconds > 0) {
                    console.log('[AUDIOPLAYER] Setting value to marker', m, seconds);
                    this.addMarker(m, seconds);
                }
                return m;
            });
        });

        const { audioUrl } = this.props;
        this.wavesurfer.load(audioUrl);
        this.audioPlayerDiv.focus();
    }
    // componentWillReceiveProps(nextProps) {
    //     const { keydown: { event } } = nextProps;
    //     if (event) {
    //         // this.setState();
    //         console.log({ key: event.which });
    //     }
    // }

    componentWillUnmount() {
        console.log('[AUDIOPLAYER] destroying player');
        if (this.wavesurfer) {
            // TODO needs detroy !
            // this.wavesurfer.destroy();
            this.wavesurfer.stop();
        }
        console.log('[AUDIOPLAYER] unmount');
    }

    playPause = () => {
        this.wavesurfer.playPause();
        this.playButton.blur();
    }

    playFromStart = () => {
        this.wavesurfer.play(0);
        this.playFromStartButton.blur();
    }

    playLast15Sec = () => {
        const endTime = Math.max(0, this.wavesurfer.getDuration() - 15);
        this.wavesurfer.play(endTime);
        this.playLast15SecButton.blur();
    }

    addMarker = (marker, time) => {
        if (time === undefined) {
            time = this.wavesurfer.getCurrentTime();
        }
        // Remove if exists
        this.removeMarker(marker);
        // New one
        const newRegion = {
            id: marker.key,
            start: time,
            end: time + 0.3,
            loop: false,
            drag: false,
            resize: false,
            color: marker.color,
        };
        this.wavesurfer.addRegion(newRegion);
        // Update State
        const newState = {};
        newState[marker.key] = secondsToHHMMSSFFF(time);
        this.setState(newState);
    }

    removeMarker = (marker) => {
        if (this.wavesurfer.regions.list && this.wavesurfer.regions.list[marker.key]) {
            this.wavesurfer.regions.list[marker.key].remove();
        }
        const newState = {};
        newState[marker.key] = secondsToHHMMSSFFF(0);
        this.setState(newState);
    }

    moveMarker = (marker, move) => {
        // Get current value
        const time = this.state[marker.key];
        // Add Substract with boundaries
        const maxDuration = this.wavesurfer.getDuration();
        const seconds = Math.min(maxDuration, Math.max(0, hHMMSSFFFToSeconds(time) + move));
        // Remove marker
        this.removeMarker(marker);
        // Reset marker
        this.addMarker(marker, seconds);
        console.log(this.wavesurfer.regions.list);
    }

    playFromMarker = (marker) => {
        const time = this.state[marker.key];
        const seconds = hHMMSSFFFToSeconds(time);
        this.wavesurfer.play(seconds);
        console.log('[AUDIOPLAYER] Playing from', seconds);
    }

    // saveMarkers = () => {
    //
    // }

    zoomChange = (event) => {
        const zoomLevel = Number(event.target.value);
        this.setState({ zoomLevel });
        this.wavesurfer.zoom(zoomLevel);
    }

    toggleLoop = () => {
        const loop = !this.state.loop;
        this.setState({ loop });
        this.loopButton.blur();
    }

    @keydownScoped(ALL_KEYS)
    keyDown(event) {
        console.log('[AUDIOPLAYER] Keydown', event);
        const { key } = event;
        if (key) {
            markersDefinition
                .filter(m => key === m.keyboardShortcut)
                .map(m => this.addMarker(m));
        }
    }

    @keydownScoped('space')
    playPauseSpace() {
        console.log('[AUDIOPLAYER] SPACE PRESSED');
        this.wavesurfer.playPause();
    }

    render() {
        const { isPlaying, loop, zoomLevel } = this.state;

        return (
            <div className="dm-audioplayer" ref={(input) => { this.audioPlayerDiv = input; }} >
                <div className="dm-audioplayer-wrapper mt-4 mb-2">
                    <div className="dm-waveform-timeline" id="wave-timeline" />
                    <div className="dm-waveform" id="waveform" />
                </div>

                <div className="dm-audioplayer-controls d-flex justify-content-center">
                    <button type="button" className="btn btn-primary mb-2 mr-sm-2" ref={(input) => { this.playButton = input; }} onClick={this.playPause}>
                        {isPlaying ? <MdPause className="mr-2" /> : <MdPlayArrow className="mr-2" />}
                        {isPlaying ? 'Pause' : 'Play'}
                    </button>
                    <button type="button" className="btn btn-outline-primary mb-2 mr-sm-2" ref={(input) => { this.playFromStartButton = input; }} onClick={this.playFromStart}>
                        Play from Start
                    </button>
                    <button type="button" className="btn btn-outline-primary mb-2 mr-sm-2" ref={(input) => { this.playLast15SecButton = input; }} onClick={this.playLast15Sec}>
                        End <MdSkipNext />
                    </button>
                    <button type="button" className={`btn ${loop ? 'btn-primary' : 'btn-outline-primary'} mb-2 mr-sm-2`} ref={(input) => { this.loopButton = input; }} onClick={this.toggleLoop}>
                        <MdLoop />
                    </button>
                    <div className="">
                        <input id="slider" type="range" min="1" max="100" step="5" value={zoomLevel} style={{ width: '200px' }} onChange={this.zoomChange} />
                    </div>
                </div>
                <div className="markers d-flex justify-content-center" >
                    <table className="table table-sm" style={{ width: 'auto' }}>
                        <tbody>
                            {markersDefinition.map(m => markerRow(m, this.state[m.key], this.addMarker, this.removeMarker, this.playFromMarker, this.moveMarker))}
                        </tbody>
                    </table>
                </div>
                <div className="markers d-flex justify-content-center" >
                    <button type="button" className="btn btn-primary btn-lg">
                        <FaSave /> Save markers
                    </button>
                </div>
            </div>
        );
    }
}

AudioPlayer.wrappedComponent.propTypes = {
    audioUrl: PropTypes.string.isRequired,
};

export default injectIntl(AudioPlayer);
//
// <ul className="nav nav-pills flex-column">
//     <li className="nav-item">
//         <NavLink className="nav-link" activeClassName="active" to="/">Nav item</NavLink>
//     </li>
//     <li className="nav-item">
//         <NavLink className="nav-link" activeClassName="active" to="/">Nav item again</NavLink>
//     </li>
//     <li className="nav-item">
//         <NavLink className="nav-link" activeClassName="active" to="/">One more nav</NavLink>
//     </li>
//     <li className="nav-item">
//         <NavLink className="nav-link" activeClassName="active" to="/">Another nav item</NavLink>
//     </li>
// </ul>
